<div *ngIf="capabilities?.length">
  <mat-chip-listbox>
    <mat-chip-option
      *ngFor="let capability of capabilities"
      class="capability-chip"
      [selected]="selectedCapability?.Id === capability.Id"
      (click)="selectCapability(capability)"
      [attr.aria-selected]="selectedCapability?.Id === capability.Id"
    >
      <div class="capability-chip-container">
        <mat-icon class="capability-tick" aria-hidden="true">check</mat-icon>
        <span class="capability-label">{{ capability.Name }}</span>
      </div>
    </mat-chip-option>
  </mat-chip-listbox>
</div>
